import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Home = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M6.00001 14V9.06667C6.00001 8.69327 6.00001 8.5066 6.07268 8.364C6.13659 8.23853 6.23858 8.1366 6.36402 8.07267C6.50663 8 6.69334 8 7.06668 8H8.93334C9.30674 8 9.49341 8 9.63601 8.07267C9.76148 8.1366 9.86341 8.23853 9.92734 8.364C10 8.5066 10 8.69327 10 9.06667V14M1.33334 6.33333L7.36001 1.81333C7.58954 1.64121 7.70428 1.55514 7.83028 1.52196C7.94154 1.49268 8.05848 1.49268 8.16974 1.52197C8.29574 1.55514 8.41048 1.64121 8.64001 1.81333L14.6667 6.33333M2.66668 5.33333V11.8667C2.66668 12.6134 2.66668 12.9868 2.812 13.272C2.93984 13.5229 3.14381 13.7269 3.39469 13.8547C3.67991 14 4.05328 14 4.80001 14H11.2C11.9467 14 12.3201 14 12.6053 13.8547C12.8562 13.7269 13.0602 13.5229 13.188 13.272C13.3333 12.9868 13.3333 12.6134 13.3333 11.8667V5.33333L9.28001 2.29333C8.82101 1.94907 8.59148 1.77695 8.33941 1.71059C8.11694 1.65203 7.88308 1.65203 7.66061 1.71059C7.40854 1.77695 7.17901 1.94907 6.72001 2.29333L2.66668 5.33333Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(Home);
